import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=60f0d8b0&"
import script from "./Messagerie.vue?vue&type=script&lang=js&"
export * from "./Messagerie.vue?vue&type=script&lang=js&"
import style0 from "./Messagerie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports